import { TransactionObjectType } from "../enums/global.enums";

export const transactionObjectTypePipe = (value: string) => {
    switch (value) {
        case TransactionObjectType.AppUser:
            return "Người dùng hệ thống";
        case TransactionObjectType.WaterUser:
            return "Hộ dùng nước"
    }
}